import { useApiClient } from '../client.js'

export const STRIPE_PAYMENT_INTENT_ACTION = '/core/v2/business_api/me/businesses/{businessId}/stripe/payment_intent/{paymentIntentId}/action'

export function postStripePaymentIntentAction ({ businessId, paymentIntentId, action }) {
  const apiClient = useApiClient()

  return apiClient.post({
    url: STRIPE_PAYMENT_INTENT_ACTION,
    urlParams: {
      businessId,
      paymentIntentId,
    },
    data: {
      action,
    },
  })
}
